import type { EntityConfig } from '../types'

export const quoteEntity: EntityConfig = {
  id: 'quote',
  displayName: 'Quote',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'draft', label: 'Draft' },
      { value: 'outstanding', label: 'Outstanding' },
      { value: 'accepted', label: 'Accepted' },
      { value: 'cancelled', label: 'Cancelled' },
    ],
    options: [
      { value: 'draft', label: 'Draft', color: 'neutral' },
      { value: 'outstanding', label: 'Outstanding', color: 'indigo' },
      { value: 'accepted', label: 'Accepted', color: 'success' },
      { value: 'cancelled', label: 'Cancelled', color: 'error' },
    ],
    mappings: {
      all: ['draft', 'outstanding', 'accepted', 'cancelled'],
      draft: ['draft'],
      outstanding: ['outstanding'],
      accepted: ['accepted'],
      cancelled: ['cancelled'],
    }
  },
  queryFields: {
    status: {
      type: 'status_array',
      urlKey: 'status'
    },
    dateRange: {
      type: 'date_range',
      urlKey: 'date'
    },
    createdDate: {
      type: 'date_range',
      urlKey: 'createdDate'
    },
    amount: {
      type: 'amount',
      urlKey: 'amount'
    },
    customerName: {
      type: 'search',
      urlKey: 'customerName'
    },
    quoteNumber: {
      type: 'search',
      urlKey: 'quoteNumber'
    },
    search: {
      type: 'search',
      urlKey: '$s'
    }
  },
  uiFilterFields: [
    'status',
    'createdDate',
    'amount',
  ]
}
